import { Box, IconButton, Paper } from "@mui/material";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./index.css";

import { Pagination, Navigation, Zoom } from "swiper/modules";
import { EzrImage, MaterialIcon } from "ui-widgets";
import React from "react";
import Asset from "datalign-module-template/models/asset";
import {
  AUDIO_EXTENSIONS,
  VIDEO_EXTENSIONS,
} from "datalign-module-template/components/extensionsList";
import EzrVideo from "datalign-module-template/components/ezr-video";
import EzrAudio from "datalign-module-template/components/ezr-audio";
import { GetFileExtension } from "datalign-module-template/helpers/GetFileExtension";
import DownloadAsset from "datalign-module-template/helpers/DownloadAsset";

const IMAGE_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".bmp",
  ".webp",
  ".svg",
  ".tiff",
];

const Carousel = ({ assets }: { assets: Asset[] }) => {
  return (
    <Box sx={{ flexGrow: 1, mb: 2 }}>
      <Paper
        square
        elevation={2}
        // sx={{
        //   display: "flex",
        //   alignItems: "center",
        //   width: "100%",
        // }}
      >
        <Swiper
          centeredSlides={true}
          autoplay={{
            // delay: 10000,
            disableOnInteraction: true,
          }}
          zoom={true}
          // style={{
          //   // "--swiper-navigation-color": "#fff",
          //   // "--swiper-pagination-color": "#fff",
          //   maxHeight: "500px",
          // }}
          lazyPreloadPrevNext={2}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Zoom, Pagination, Navigation]}
          style={{
            width: "100%",
            maxHeight: "500px",
          }}
        >
          {assets
            .filter(
              (file) =>
                file.name &&
                IMAGE_EXTENSIONS.includes(GetFileExtension(file.name)),
            )
            .map((file) => (
              <SwiperSlide key={file.guid} className="swiper-slide" zoom>
                <div className="swiper-zoom-container">
                  <EzrImage
                    src={file.presigned_url}
                    alt={file.name}
                    loading="lazy"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                      objectPosition: "center",
                      display: "block",
                      margin: "auto",
                      width: "80%",
                      height: "90%",
                    }}
                  />
                </div>
                <IconButton
                  onClick={() => DownloadAsset(file)}
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent black
                    color: "#fff", // white icon color
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.7)", // darker on hover
                    },
                    boxShadow: 1, // subtle shadow
                  }}
                >
                  <MaterialIcon icon="download" />
                </IconButton>
              </SwiperSlide>
            ))}
          {assets
            .filter(
              (file) =>
                file.name &&
                VIDEO_EXTENSIONS.includes(GetFileExtension(file.name)),
            )
            .map((file) => (
              <SwiperSlide key={file.guid} className="swiper-slide">
                <EzrVideo
                  src={file.presigned_url}
                  controls
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    objectPosition: "center",
                    display: "block",
                    margin: "auto",
                    width: "80%",
                    height: "90%",
                  }}
                />
                <IconButton
                  onClick={() => DownloadAsset(file)}
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent black
                    color: "#fff", // white icon color
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.7)", // darker on hover
                    },
                    boxShadow: 1, // subtle shadow
                  }}
                >
                  <MaterialIcon icon="download" />
                </IconButton>
              </SwiperSlide>
            ))}
          {assets
            .filter(
              (file) =>
                file.name &&
                AUDIO_EXTENSIONS.includes(GetFileExtension(file.name)),
            )
            .map((file) => (
              <SwiperSlide
                key={file.guid}
                className="swiper-slide"
                style={{ alignSelf: "center" }}
              >
                <EzrAudio
                  src={file.presigned_url}
                  controls
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    objectPosition: "center",
                    display: "block",
                    margin: "auto",
                    width: "80%",
                    height: "90%",
                  }}
                />
                <IconButton
                  onClick={() => DownloadAsset(file)}
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.7)",
                    },
                    boxShadow: 1,
                  }}
                >
                  <MaterialIcon icon="download" />
                </IconButton>
              </SwiperSlide>
            ))}
        </Swiper>
      </Paper>
    </Box>
  );
};

export default Carousel;
